import { convertSeparatedDateTimeWithTimeZoneToServerUTC } from 'utils/dateTimeFormat.js';

const parseDateTime = (dateStr, timeStr) => {
  // dateStr: "MM / DD / YYYY"
  // timeStr: "HH : MM"
  if (!dateStr) return { year: '1900', month: '01', date: '01', hours: '0', minutes: '00' };
  const dateParts = dateStr.split('/').map(p => p.trim());
  const timeParts = timeStr ? timeStr.split(':').map(p => p.trim()) : ['0', '00'];
  return {
    month: dateParts[0] || '01',
    date: dateParts[1] || '01',
    year: dateParts[2] || '1900',
    hours: timeParts[0] || '0',
    minutes: timeParts[1] || '00'
  };
};

const convertDateCollectedFromToServerUTC = (inputData, clientTz) => {
  if (clientTz === 'TZNA' || clientTz === null) {
    throw new Error(`Client Timezone is not available, please make sure the client’s timezone is set correctly.`)
  } else {
    const { year, month, date, hours, minutes } = parseDateTime(inputData.dateCollected, inputData.timeCollected);
    return convertSeparatedDateTimeWithTimeZoneToServerUTC(
      year,
      month,
      date,
      hours,
      minutes,
      inputData.timeCollectedAmPm,
      clientTz,
    )
  }
}

const getClientTzFromExtraSelectedOptionData = (extraSelectedOptionData) => {
  if (extraSelectedOptionData.hasOwnProperty('clientId') && extraSelectedOptionData.clientId.hasOwnProperty('clientTz')) {
    return extraSelectedOptionData.clientId.clientTz;
  }
  else {
    return false;
  }
}

const convertDateReceivedFromToServerUTC = (inputData, clientTz) => {
  if (clientTz === 'TZNA' || clientTz === null) {
    throw new Error(`Client Timezone is not available, please make sure the client’s timezone is set correctly.`)
  } else {
    const { year, month, date, hours, minutes } = parseDateTime(inputData.dateReceived, inputData.timeReceived);
    return convertSeparatedDateTimeWithTimeZoneToServerUTC(
      year,
      month,
      date,
      hours,
      minutes,
      inputData.dateReceivedAmPm,
      clientTz,
    )
  }
}


export {
  convertDateCollectedFromToServerUTC,
  convertDateReceivedFromToServerUTC,
  getClientTzFromExtraSelectedOptionData,
}